/* eslint-disable max-classes-per-file */
type UserCustomSignatureProps = {
    id: string;
    userId: string;
    isFavorite: boolean;
    avatarURL?: string;
    name?: string;
    email?: string;
    phone?: string;
    jobTitle?: string;
    companyName?: string;
    website?: string;
    other?: string;
};

class UserCustomSignatureParams {
    id: string;

    userId: string;

    isFavorite: boolean;

    avatarURL?: string;

    name?: string;

    email?: string;

    phone?: string;

    jobTitle?: string;

    companyName?: string;

    website?: string;

    other?: string;

    constructor({
        id,
        userId,
        isFavorite,
        avatarURL,
        name,
        email,
        phone,
        jobTitle,
        companyName,
        website,
        other,
    }: UserCustomSignatureProps) {
        this.id = id;
        this.userId = userId;
        this.isFavorite = isFavorite;
        this.avatarURL = avatarURL;
        this.name = name;
        this.email = email;
        this.phone = phone;
        this.jobTitle = jobTitle;
        this.companyName = companyName;
        this.website = website;
        this.other = other;
    }
}

export default UserCustomSignatureParams;

type UserCustomSignatureInputProps = {
    avatar?: string;
    name?: string;
    email?: string;
    phone?: string;
    jobTitle?: string;
    companyName?: string;
    website?: string;
    other?: string;
};

export class UserCustomSignatureInput {
    avatar?: string;

    name?: string;

    email?: string;

    phone?: string;

    jobTitle?: string;

    companyName?: string;

    website?: string;

    other?: string;

    constructor({
        avatar,
        name,
        email,
        phone,
        jobTitle,
        companyName,
        website,
        other,
    }: UserCustomSignatureInputProps) {
        this.avatar = avatar;
        this.name = name;
        this.email = email;
        this.phone = phone;
        this.jobTitle = jobTitle;
        this.companyName = companyName;
        this.website = website;
        this.other = other;
    }
}
